module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-startseite-luftballons-b7b0e7d55076e921edbe8b34e9f3a506.png";